import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { companionsApi, CompanionItem } from '../../../shared/api/companions'

const CompanionDetailPage: React.FC = () => {
  const { id } = useParams()
  const [data, setData] = useState<CompanionItem | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!id) return
    let mounted = true
    companionsApi
      .get(Number(id))
      .then((res) => { if (mounted) { setData(res); setError(null) } })
      .catch((e) => setError(e?.message || '加载失败'))
      .finally(() => setLoading(false))
    return () => { mounted = false }
  }, [id])

  if (loading) return <div className="p-4">加载中...</div>
  if (error) return <div className="p-4 text-red-600">{error}</div>
  if (!data) return <div className="p-4">陪跑员不存在</div>

  return (
    <div className="p-4">
      <h1 className="text-xl font-semibold mb-4">{data.name}</h1>
      <div className="text-gray-600 mb-2">{data.city || '未知城市'}</div>
      <div className="mb-2">评分：{data.rating ?? 0}（{data.review_count ?? 0}）</div>
      <div className="mb-2">价格：{data.price ?? 0}</div>
      <div className="mb-2">PB：全马 {data.pb_full || '-'}，半马 {data.pb_half || '-'}</div>
      <div className="mb-2">特长：{data.specialties || '-'}</div>
    </div>
  )
}

export default CompanionDetailPage

